import { useQuery } from "react-query";
import { PrintTemplateService } from "../../../services/template/printTemplate.service";
export var usePrintTemplates = function () {
    var query = useQuery('allPrintTemplates', function () {
        return PrintTemplateService.getAllTemplates({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    return query;
};
export var usePrintTemplatesByType = function (type) {
    var _a;
    var query = useQuery('printTemplatesByType', function () {
        return PrintTemplateService.getAllTemplates({
            limit: {
                offset: 0,
                limit: 1000,
                sort: [{ field: "name", direction: "ASC" }]
            }
        });
    });
    var allTemplates = ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
    return allTemplates.filter(function (template) { return template.type === type; });
};
